import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRol } from "../../Context";
import "./Footer.css";
import menuMovil from '../../icons/menu-outline.svg';
import home from '../../icons/flag-sharp.svg';
import lead from '../../icons/person-sharp.svg';
import task from '../../icons/calendar-sharp.svg';
import project from '../../icons/business-sharp.svg';
import team from '../../icons/people-sharp.svg';
import analisis from '../../icons/bar-chart-sharp.svg';
import afinidad from '../../icons/options-sharp.svg';
import profileMovil from '../../icons/person-circle-outline copy.svg';
import passwordMovil from '../../icons/key-sharp copy.svg';
import facturaMovil from '../../icons/cash-sharp copy.svg';
import infoUserMovil from '../../icons/information-circle-outline.svg';
import tutoriales from '../../icons/Imagen2.svg';
import tranfer from '../../icons/Transfer.svg';

function Footer({ toggleRightMenu, toggleLeftMenu }) {

    const { dataProfile, setDataProfile, setLoading } = useRol();

    let nombre = dataProfile ? dataProfile.first_name : "User";

    const location = useLocation();
    const rutaActual = location.pathname.substring(1);

    const icons = [
        { icon: home, alt: 'Inicio' },
        { icon: lead, alt: 'Contactos' },
        { icon: tutoriales, alt: 'Tutoriales' },
        { icon: task, alt: 'Tareas' },
        { icon: tranfer, alt: 'Subir-contactos' },
        { icon: project, alt: 'Proyectos' },
        { icon: team, alt: 'Equipo' },
        { icon: analisis, alt: 'Analisis' },
        { icon: afinidad, alt: 'Afinidad' },
        { icon: profileMovil, alt: 'Perfil' },
        { icon: passwordMovil, alt: 'Contrasena' },
        { icon: facturaMovil, alt: 'Facturacion' },
        { icon: lead, alt: 'Perfil-de-contacto' },
        { icon: project, alt: 'Perfil-de-proyecto' },
        { icon: infoUserMovil, alt: 'Perfil-de-usuario' },
    ];

    const menuItem = icons.find(item => item.alt === rutaActual);
    const formattedText = menuItem ? menuItem.alt.replace(/-/g, ' ') : '';

    useEffect(() => {
        if (nombre === null) {
            setLoading(true);
            setDataProfile();
        }
        const textElements = document.querySelectorAll('.texto');
        textElements.forEach((element) => {
            const text = element.textContent;
            const firstLetter = document.createElement('span');
            firstLetter.className = 'primera-letra';
            firstLetter.textContent = text[0];
            element.textContent = ''; // Elimina el texto original
            element.appendChild(firstLetter);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nombre]);

    return (
        <>
            {/* footer movil */}
            <footer className="footer">
                <div className="footer-icon" onClick={toggleLeftMenu}>
                    <img className="icon" src={menuMovil} alt="=" />
                </div>
                <div className="footer-title">
                    <img src={menuItem ? menuItem.icon : null} alt={formattedText} />
                    <label>{formattedText}</label>
                </div>
                <div className="footer-icon" onClick={toggleRightMenu}>
                    <div className="texto circulo-bg">
                        {nombre}
                    </div>
                </div>
            </footer>
        </>
    )
}

export { Footer }